<template>
  <div class="cms-richtext-block">
    <header v-if="block.title || block.subtitle" class="cms-richtext-header">
      <h3 v-if="block.title" class="cms-richtext-title">{{ block.title }}</h3>
      <p v-if="block.subtitle" class="cms-richtext-subtitle">{{ block.subtitle }}</p>
    </header>
    <div v-if="block.bodyContent" class="cms-richtext-body" v-html="block.bodyContent"></div>
  </div>
</template>

<script>
export default {
  name: 'RichTextBlock',
  props: {
    block: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.cms-richtext-header {
  margin-bottom: 14px;
}

.cms-richtext-title {
  margin: 0 0 6px;
  color: var(--primary);
  font-size: 20px;
  line-height: 1.4;
}

.cms-richtext-subtitle {
  margin: 0;
  color: var(--subtle);
  font-size: 15px;
  line-height: 1.6;
}

.cms-richtext-body {
  color: var(--text);
  font-size: 16px;
  line-height: 1.9;
}

.cms-richtext-body >>> p {
  margin: 0 0 1em;
}

.cms-richtext-body >>> p:last-child {
  margin-bottom: 0;
}

.cms-richtext-body >>> a {
  color: var(--primary-soft);
  text-decoration: underline;
}

.cms-richtext-body >>> a:hover {
  color: var(--primary);
}

.cms-richtext-body >>> ul,
.cms-richtext-body >>> ol {
  margin: 0 0 1em;
  padding-left: 1.5em;
}

.cms-richtext-body >>> img {
  max-width: 100%;
  height: auto;
  border-radius: var(--front-radius);
}
</style>
